import { lazyLoad } from 'app/utils/loadable';

export const RegisterPage = lazyLoad(
  () => import('./register-page'),
  (module) => module.RegisterPage
);
